module.exports = __webpack_public_path__ + "img/ro.ce48887a.svg";